import {
  Grid,
  Typography,
  Button,
  createStyles,
  makeStyles,
  Theme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Dialog,
  Paper,
  Box,
  IconButton,
} from '@material-ui/core';
import { Close, Delete } from '@material-ui/icons';
import React, { useContext, useState } from 'react';
import EmailTextField from '../email-text-field';
import PersonDropdown from '../person-dropdown/PersonDropdown';
import { useIsMobile } from '../../util/style-utils';
import { useTranslation } from '../../hooks/useTranslation';
import EditIcon from '@material-ui/icons/Edit';
import { Model } from './chargePointForm.rules';
import {
  AuthDriverList,
  ChargePointStatus,
  LinkedPerson,
  ManagePerRelationshipResponse,
  Maybe,
} from '../../__generated__/pge-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DriverIcon from '../../static/driver.svg';
import AddDriverIcon from '../../static/AddDriver.svg';
import colors from '../../themes/main-colors';
import CloseIcon from '@material-ui/icons/Close';
import OpConnectIcon from '../../images/opconnect_icon.png';
import { EMAIL_REGEX } from '../../util/form-validation';
import {
  LanguageContext,
  SupportedLanguages,
} from '../../providers/LanguageProvider';
import PGEButton from '../buttons/PGE-Button';

const useStyles = (isMobile?: boolean, language?: SupportedLanguages) =>
  makeStyles((theme: Theme) => {
    return createStyles({
      deletePerson: {
        borderRadius: '20px',
      },
      icon: {
        width: '50px',
      },
      statusIcon: {
        width: '25px',
        height: '25px',
      },
      iconStyles: {
        paddingLeft: '10px',
        marginBottom: '5px',
      },
      discountStatus: {
        marginTop: '10px',
      },
      buttonStyles: {
        marginLeft: '5px',
      },
      displayFlex: {
        display: 'flex',
      },
      displayBlock: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      container: {
        display: isMobile ? 'block' : 'flex',
        width: '-webkit-fill-available',
        background: colors.cloudGrey2,
        padding: '1rem',
        borderRadius: '5px',
      },
      item: {
        width: '46%',
      },
      accordionSummaryStyles: {
        display: 'flex',
        gap: '15px',
        margin: '-10px 0px',
      },
      headerInfoStyles: {
        fontSize: isMobile ? '16px' : '22px',
        fontWeight: 600,
        alignContent: 'center',
      },
      authDriverStyles: {
        fontSize: isMobile ? '16px' : '18px',
        fontWeight: 600,
        alignContent: 'center',
        textTransform: 'capitalize',
      },
      font600: {
        fontWeight: 600,
        textTransform: 'capitalize',
      },
      accessCode: {
        fontWeight: 600,
        marginLeft: '5px',
      },
      opConnectEmailStyles: {
        fontWeight: 600,
        marginLeft: '5px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'inherit',
      },
      discountTypes: {
        fontWeight: 600,
        color: colors.sparkBlue,
        marginLeft: '5px',
      },
      accordionDetailsStyles: {
        display: 'grid',
      },
      driverNameBox: {
        display: 'flex',
        gap: '15px',
        marginBottom: '10px',
      },
      driverNameStyles: {
        alignContent: 'center',
        marginRight: language === SupportedLanguages.English ? '77px' : '31px',
      },
      opConnectEmail: {
        display: isMobile ? 'block' : 'flex',
        gap: '15px',
        marginTop: '10px',
      },
      personDropdownBox: {
        display: isMobile ? 'block' : 'flex',
        gap: '15px',
      },
      personDropdownName: {
        alignContent: 'center',
        marginRight: '75px',
      },
      buttonContainer: {
        textAlign: 'end',
        padding: '1rem',
      },
      addButton: {
        backgroundColor: '#27788c',
        marginLeft: '10px',
        color: '#FFF',
        padding: isMobile ? '6px 20px' : '6px 12px',
        minWidth: isMobile ? '22px' : '35px',
        maxWidth: isMobile ? '22px' : '40px',
        maxHeight: isMobile ? '30px' : '35px',
        '&:hover': {
          background: colors.sparkBlue,
        },
      },
      editButton: {
        color: '#27788c',
        padding: '0',
        minWidth: isMobile ? '22px' : '35px',
        maxWidth: isMobile ? '22px' : '40px',
        maxHeight: isMobile ? '30px' : '35px',
      },
      closeButton: {
        color: '#27788c',
        padding: '0',
        marginTop: '5px',
        marginLeft: '5px',
        minWidth: isMobile ? '22px' : '35px',
        maxWidth: isMobile ? '22px' : '40px',
        maxHeight: isMobile ? '30px' : '35px',
      },
      statusContainer: {
        display: 'flex',
        alignItems: 'center',
      },
      fullStatusContiner: {
        display: 'block',
        width: isMobile ? '100%' : '49%',
      },
      imageContainer: {
        width: '30px',
        height: '30px',
      },
      statusStyles: {
        fontWeight: 600,
        marginLeft: '5px',
      },
      nameContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      },
      vdivider: {
        margin: isMobile
          ? theme.spacing(1, 2, 2, 0)
          : theme.spacing(1, 2, 0, 0),
        backgroundColor: 'white',
        width: isMobile ? '100%' : '2px',
      },
      removePersonDataModalWrapper: {
        '& .MuiDialog-paperWidthSm': {
          maxWidth: '500px',
          width: '80%',
        },
      },
      modalBody: {
        marginTop: theme.spacing(1),
        '& > *': {
          marginTop: theme.spacing(1),
        },
      },
      closeBtn: {
        position: 'absolute',
        top: 10,
        right: 10,
        padding: 0,
      },
      removePersonDataModal: {
        padding: theme.spacing(3),
        borderRadius: '5px',
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(4, 3, 3, 3),
        },
      },
      dialogBtn: {
        [theme.breakpoints.down('sm')]: {
          textAlign: 'center',
        },
        [theme.breakpoints.up('sm')]: {
          display: 'flex',
          justifyContent: 'center',
        },
      },
    });
  });

type ChargePointDriverData = {
  headerInfo: string;
  driverType: string;
  driverEmail: string;
  form: any;
  personList: LinkedPerson[] | undefined;
  setDriverInfo: (driver: LinkedPerson) => void;
  currentPerson: LinkedPerson | undefined;
  excludePersonList: LinkedPerson[] | undefined;
  loggedInPersonType: string;
  setShowRemovePersonDialog: (isOpen: boolean) => void;
  setSelctedPersonForDelete: (data: any) => void;
  defaultFormValues: Model;
  getIQBDStatusAuthDriver: any;
  setIsUserEligibleToAdd: (e: string) => void;
  chargePoint: ManagePerRelationshipResponse;
  isUserEligibleToAdd: string;
  removedDriverDetails: any;
  setRemovedDriverDetails: any;
};

export function ChargePointDriver(props: ChargePointDriverData) {
  const {
    headerInfo,
    driverType,
    setDriverInfo,
    currentPerson,
    excludePersonList,
    loggedInPersonType,
    setShowRemovePersonDialog,
    setSelctedPersonForDelete,
    driverEmail,
    form,
    personList,
    defaultFormValues,
    getIQBDStatusAuthDriver,
    setIsUserEligibleToAdd,
    chargePoint,
    removedDriverDetails,
    setRemovedDriverDetails,
    isUserEligibleToAdd,
  } = props;
  const isMobile = useIsMobile();
  const { t, richT } = useTranslation();
  const { language } = useContext(LanguageContext);
  const classes = useStyles(isMobile, language)();
  const [editOpConnectEmail, setEditOpConnectEmail] = useState(false);
  const [showIsIQPCDEligibleDialog, setShowIsIQPCDEligibleDialog] = useState(
    false,
  );
  const driverDetails = form.values[driverType as keyof Model];
  const driverAccessCode =
    driverType === 'primeDriver'
      ? form.values.primeDriverAccessCode
      : driverType === 'secondaryDriver'
      ? form.values.secondaryDriverAccessCode
      : form.values.thirdDriverAccessCode;
  const driverChargePointStatus =
    driverType === 'primeDriver'
      ? form.values.primeDriverStatus
      : driverType === 'secondaryDriver'
      ? form.values.secondaryDriverStatus
      : form.values.thirdDriverStatus;
  const driverOpConnectStatus =
    driverType === 'primeDriver'
      ? form.values.primeDriverOpconnectStatus
      : driverType === 'secondaryDriver'
      ? form.values.secondaryDriverOpconnectStatus
      : form.values.thirdDriverOpconnectStatus;
  const isAccordionDisabled = () => {
    if (
      driverType === 'primeDriver' ||
      (driverType === 'secondaryDriver' &&
        form.values.primeDriver?.length > 0 &&
        !removedDriverDetails['primeDriver'] &&
        personList &&
        personList?.length > 1) ||
      (driverType === 'thirdDriver' &&
        form.values.secondaryDriver?.length > 0 &&
        !removedDriverDetails['secondaryDriver'] &&
        personList &&
        personList?.length > 2)
    ) {
      return false;
    }
    return true;
  };

  const getDriverOpConnectEmail = () => {
    if (defaultFormValues) {
      if (driverEmail === 'primeDriverOpConnectEmail') {
        return defaultFormValues.primeDriverOpConnectEmail;
      } else if (driverEmail === 'secondaryDriverOpConnectEmail') {
        return defaultFormValues.secondaryDriverOpConnectEmail;
      } else if (driverEmail === 'thirdDriverOpConnectEmail') {
        return defaultFormValues.thirdDriverOpConnectEmail;
      }
    }
    return null;
  };

  const getStatusTranslations = (statusIQBD: ChargePointStatus) => {
    switch (statusIQBD) {
      case ChargePointStatus.Approved:
        return t('APPROVED');
      case ChargePointStatus.NotConnected:
        return t('NOT_CONNECTED');
      case ChargePointStatus.NotManaged:
        return t('NOT_MANAGED');
      case ChargePointStatus.Pending:
        return t('PENDING');
      case ChargePointStatus.Rejected:
        return t('REJECTED');
      case ChargePointStatus.Removed:
        return t('REMOVED');
    }
  };

  const opConnectEmail = getDriverOpConnectEmail();
  const updatedEmail = form.props(driverEmail as keyof Model).value;
  const isInvalidEmail =
    updatedEmail &&
    updatedEmail?.trim() !== '' &&
    !EMAIL_REGEX.test(updatedEmail);
  return (
    <div>
      <Accordion
        style={{ marginBottom: '15px' }}
        disabled={isAccordionDisabled()}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid className={classes.accordionSummaryStyles}>
            {driverAccessCode ? (
              <DriverIcon className={classes.icon} />
            ) : (
              <AddDriverIcon className={classes.icon} />
            )}
            <Grid className={classes.displayBlock}>
              <Typography className={classes.headerInfoStyles}>
                {t(headerInfo)}
              </Typography>
              {driverAccessCode && (
                <Grid className={classes.driverNameBox}>
                  <Typography className={classes.authDriverStyles}>
                    {currentPerson?.name}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetailsStyles}>
          {!(
            driverOpConnectStatus === ChargePointStatus.Approved ||
            driverOpConnectStatus === ChargePointStatus.Pending
          ) && (
            <Grid className={classes.personDropdownBox}>
              <Typography className={classes.personDropdownName}>
                {t('NAME')}:
              </Typography>
              <Grid style={{ width: '100%' }}>
                <PersonDropdown
                  onChange={per => {
                    const { opConnectStatus, chargePointstatus } =
                      chargePoint?.authDriverList?.filter(
                        (driver: Maybe<AuthDriverList>) => {
                          return per?.personId === driver?.personId;
                        },
                      )[0] || ({} as AuthDriverList);
                    if (
                      opConnectStatus === ChargePointStatus.Removed ||
                      chargePointstatus === ChargePointStatus.Removed
                    ) {
                      setRemovedDriverDetails({
                        ...removedDriverDetails,
                        [driverType]: true,
                      });
                      setShowIsIQPCDEligibleDialog(true);
                      void form?.setValue(driverType as keyof Model, undefined);
                    } else {
                      setRemovedDriverDetails({
                        ...removedDriverDetails,
                        [driverType]: false,
                      });
                      setShowIsIQPCDEligibleDialog(false);
                      const isEligible =
                        per?.encryptedPersonId &&
                        getIQBDStatusAuthDriver(per.encryptedPersonId);
                      isEligible?.then((res: boolean) => {
                        if (!res) {
                          setIsUserEligibleToAdd('invalid');
                          setShowIsIQPCDEligibleDialog(true);
                          setRemovedDriverDetails({
                            ...removedDriverDetails,
                            [driverType]: true,
                          });
                          void form?.setValue(
                            driverType as keyof Model,
                            undefined,
                          );
                        } else {
                          setIsUserEligibleToAdd('valid');
                          setRemovedDriverDetails({
                            ...removedDriverDetails,
                            [driverType]: false,
                          });
                          setDriverInfo(per);
                          void form?.setValue(
                            driverType as keyof Model,
                            per?.personId,
                          );
                        }
                      });
                    }
                  }}
                  personList={personList || []}
                  excludePersons={excludePersonList}
                  currentPerson={currentPerson}
                  removeSelectedUser={
                    removedDriverDetails[driverType] &&
                    !showIsIQPCDEligibleDialog
                  }
                />
              </Grid>
            </Grid>
          )}
          {form &&
            currentPerson &&
            driverDetails &&
            !driverAccessCode &&
            !(
              removedDriverDetails[driverType] && !showIsIQPCDEligibleDialog
            ) && (
              <>
                <Grid className={classes.opConnectEmail}>
                  <Typography className={classes.driverNameStyles}>
                    {t('EMAIL_TEXT')}
                    {':'}
                  </Typography>
                  <EmailTextField
                    name={driverEmail}
                    margin={'none'}
                    data-testid="email"
                    label={t('DRIVER_OPCONNECT_EMAIL')}
                    inputProps={{ minLength: 1, maxLength: 60 }}
                    {...form.props(driverEmail as keyof Model)}
                    error={isInvalidEmail}
                    helperText={isInvalidEmail && 'Enter a Valid Email ID'}
                  />
                </Grid>
              </>
            )}
          {showIsIQPCDEligibleDialog && (
            <Dialog
              open={showIsIQPCDEligibleDialog}
              onClose={() => setShowIsIQPCDEligibleDialog(false)}
              scroll={'body'}
              className={classes.removePersonDataModalWrapper}
              disableScrollLock
            >
              <Paper className={classes.removePersonDataModal}>
                <Box>
                  <Grid container justify="space-between">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      onClick={() => setShowIsIQPCDEligibleDialog(false)}
                      className={classes.closeBtn}
                    >
                      <Close />
                    </IconButton>
                  </Grid>

                  <Box className={classes.modalBody}>
                    <Typography variant={'h3'}>
                      {isUserEligibleToAdd === 'invalid'
                        ? t('IQPCD_SELECT_USER_ERROR_MESSAGE')
                        : removedDriverDetails[driverType] &&
                          richT('IQPCD_REMOVED_USER_ERROR_MESSAGE')}
                    </Typography>
                    <Grid className={classes.dialogBtn}>
                      <PGEButton
                        size="large"
                        color="secondary"
                        variant="outlined"
                        className={classes.buttonStyles}
                        onClick={() => {
                          setShowIsIQPCDEligibleDialog(false);
                          setIsUserEligibleToAdd('valid');
                        }}
                      >
                        {t('CLOSE')}
                      </PGEButton>
                    </Grid>
                  </Box>
                </Box>
              </Paper>
            </Dialog>
          )}

          {driverAccessCode && (
            <Grid className={classes.container}>
              <Grid className={classes.fullStatusContiner}>
                <Grid className={classes.displayFlex}>
                  <img
                    className={classes.imageContainer}
                    src="https://chargehub.com/hubfs/Partner%20Logos/Round/Chargepoint.png"
                  />{' '}
                  <Typography className={classes.discountTypes}>
                    {t('CHARGEPOINT')}
                  </Typography>
                </Grid>
                <Grid className={classes.statusContainer}>
                  <Typography variant="subtitle1">
                    {t('CHARGEPOINT_ACCESS_CODE_TEXT')}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    className={classes.accessCode}
                  >
                    {driverAccessCode}
                  </Typography>
                </Grid>
                <Grid className={classes.displayFlex}>
                  <Typography variant="subtitle1">{t('STATUS')}</Typography>
                  <Typography
                    variant="subtitle1"
                    className={classes.statusStyles}
                    style={{
                      color:
                        driverChargePointStatus === ChargePointStatus.Approved
                          ? colors.shoreGreen
                          : '',
                    }}
                  >
                    {getStatusTranslations(
                      driverChargePointStatus,
                    )?.toUpperCase()}
                  </Typography>
                </Grid>
              </Grid>
              {isMobile ? (
                <Divider className={classes.vdivider} />
              ) : (
                <Divider
                  orientation="vertical"
                  flexItem
                  className={classes.vdivider}
                />
              )}
              <Grid className={classes.fullStatusContiner}>
                <Grid className={classes.displayFlex}>
                  <img src={OpConnectIcon} className={classes.imageContainer} />
                  <Typography className={classes.discountTypes}>
                    {t('OPCONNECT')}
                  </Typography>
                </Grid>
                <Grid className={classes.statusContainer}>
                  {!editOpConnectEmail ? (
                    <>
                      <Typography variant="subtitle1">
                        {t('EMAIL')}
                        {':'}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        className={classes.opConnectEmailStyles}
                      >
                        {opConnectEmail}
                      </Typography>
                      {!(
                        driverOpConnectStatus === ChargePointStatus.Approved
                      ) && (
                        <Button
                          className={classes.editButton}
                          title={t('EDIT_EMAIL')}
                          onClick={(e: any) => {
                            setEditOpConnectEmail((preVal: boolean) => !preVal);
                          }}
                        >
                          <EditIcon
                            fontSize="small"
                            style={{
                              marginLeft: opConnectEmail ? '' : '5rem',
                            }}
                          />
                        </Button>
                      )}
                    </>
                  ) : (
                    <div style={{ display: 'contents' }}>
                      <EmailTextField
                        name={driverEmail}
                        label={t('EMAIL_TEXT')}
                        style={{ background: colors.cloudGrey2 }}
                        autoComplete={t('EMAIL_ADDRESS')}
                        size={'small'}
                        inputProps={{
                          minLength: 1,
                          maxLength: 60,
                        }}
                        {...form.props(driverEmail as keyof Model)}
                        error={isInvalidEmail}
                        helperText={isInvalidEmail && 'Enter a Valid Email ID'}
                      />
                      <Button
                        className={classes.closeButton}
                        title={t('CLOSE_EMAIL')}
                        onClick={(e: any) => {
                          setEditOpConnectEmail((preVal: boolean) => {
                            form.props(driverEmail as keyof Model).onChange({
                              target: {
                                name: driverEmail,
                                value: opConnectEmail,
                              },
                            });
                            return !preVal;
                          });
                        }}
                      >
                        <CloseIcon />
                      </Button>
                    </div>
                  )}
                </Grid>
                <Grid className={classes.displayFlex}>
                  <Typography variant="subtitle1">{t('STATUS')}</Typography>
                  <Typography
                    variant="subtitle1"
                    className={classes.statusStyles}
                    style={{
                      color:
                        driverOpConnectStatus === ChargePointStatus.Approved
                          ? colors.shoreGreen
                          : '',
                    }}
                  >
                    {getStatusTranslations(
                      driverOpConnectStatus,
                    )?.toUpperCase()}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid className={classes.buttonContainer}>
            {loggedInPersonType !== 'AUTHUSR' && (
              <Button
                color={'primary'}
                variant={'contained'}
                disabled={!currentPerson || !driverAccessCode}
                title={t('REMOVE_USER')}
                style={{
                  color: 'white',
                  backgroundColor:
                    !currentPerson || !driverAccessCode
                      ? 'lightgrey'
                      : '#d44030',
                  padding: isMobile ? '6px 20px' : '6px 12px',
                  borderRadius: '5px',
                  minWidth: isMobile ? '22px' : '35px',
                  maxWidth: isMobile ? '22px' : '40px',
                  maxHeight: isMobile ? '30px' : '35px',
                }}
                className={classes.deletePerson}
                onClick={() => {
                  setShowRemovePersonDialog(true);
                  setSelctedPersonForDelete({
                    personId: currentPerson?.personId!,
                    personName: currentPerson?.name!,
                    email: currentPerson?.email!,
                    accessCode: driverAccessCode,
                  });
                }}
                data-testid="done"
              >
                <Delete fontSize="small" />
              </Button>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
